import { provide } from "@lit/context";
import { LitElement, html, css } from "lit";
import { customElement, property } from "lit/decorators.js"
import { subscriberKeyContext } from "../subscriber-context";

@customElement("subscriber-key-provider")
export class SubscriberKeyProvider extends LitElement {
  static styles = [
    css`
      :host {
        display: contents
      }
    `
  ];

  @provide({ context: subscriberKeyContext })
  @property({ type: Number, attribute: 'subscriber-key' }) subscriberKey!: number;

  render() {
    return html`<slot></slot>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "subscriber-key-provider": SubscriberKeyProvider;
  }
}
